module.exports = __webpack_public_path__ + "img/bedstop.53025305.png";